import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Link, browserHistory } from 'react-router';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import Header from '../components/Header';
import withUser from '../common/withUser';
import withServerUrl from '../common/withServerUrl';
import {
  storeUser,
  storeServerUrl,
  sortData,
  storeVersionCode
} from '../common/globals';
import withGoBack from '../common/withGoBack';
import Bugsnag from '../helpers/bugsnag';

class Office extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offices: []
    };
  }

  _onClickOffice = async (id) => {
    try {
      const {
        user, setUser, setServerUrl, goBack, setGoBack
      } = this.props;
      const territoriesData = user.territories.find((item) => item.offices.some(
        (office) => office.id === id
      ));
      const userData = Object.assign(user, {
        office: id, territoryId: territoriesData.id
      });
      setUser(userData);
      const serverData = {
        server: territoriesData.server,
        aipUrl: territoriesData.httpUrlApiNew
      };
      await storeServerUrl(serverData);
      setServerUrl(serverData);
      storeUser(userData);
      storeVersionCode();
      goBack.push(window.location.pathname);
      setGoBack(goBack);
      browserHistory.push('/team');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { user } = this.props;
      const { offices } = this.state;
      if (user.hasOwnProperty('territories')) {
        user.territories.map((territoriesData) => {
          if (territoriesData.hasOwnProperty('offices')) {
            territoriesData.offices.map((officeData) => {
              offices.push(officeData);
            });
          }
        });
      }
      const sortOffice = sortData(offices, 'name');
      this.setState({ offices: sortOffice });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { offices } = this.state;
    return (
      <section className="list-section">
        <Header
          title="Offices"
          logout
        />
        <div className="container">
          <ul className="select-list list-unstyled">
            {
              offices.length > 0
                ? offices.map((office, index) => (
                  <Link style={{ cursor: 'pointer' }} key={index} onClick={() => this._onClickOffice(office.id)}>
                    <li>{office.name}</li>
                  </Link>
                ))
                : <h6 className="text-center mt-5">No office available</h6>
            }
          </ul>
        </div>
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'OfficeForm'
});

export default withGoBack(
  withServerUrl(
    withUser(
      withForm(
        withNotify(
          withLoader(
            Office
          )
        )
      )
    )
  )
);
